// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px)";
var _4 = "wrapper-SEH68";
var _5 = "container-3z6bj";
var _6 = "header-1wOXo";
var _7 = "header_wrapper-TAGKK";
var _8 = "title-lSi-p";
var _9 = "close__text-lnwSV";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet", _4 as "wrapper", _5 as "container", _6 as "header", _7 as "header_wrapper", _8 as "title", _9 as "close__text" }
export default { "__esModule": _1, "mobile": _2, "tablet": _3, "wrapper": _4, "container": _5, "header": _6, "header_wrapper": _7, "title": _8, "close__text": _9 }
